import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import "./AdminPreview.css";

export default function AdminPreview() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProduct = async () => {
      try {
        const snap = await getDoc(doc(db, "workCards", id));
        if (snap.exists()) {
          setProduct({ id: snap.id, ...snap.data() });
        } else {
          setProduct(null);
        }
      } catch (err) {
        console.error(err);
        setProduct(null);
      } finally {
        setLoading(false);
      }
    };

    loadProduct();
  }, [id]);

  if (loading) return <div className="admin-preview-loading">Loading...</div>;
  if (!product) return <div className="admin-preview-loading">Product not found</div>;

  return (
    <div className="admin-preview-container">
      <div className="admin-preview-card">

        {/* IMAGE */}
        <div className="admin-preview-image-wrapper">
          <img src={product.image} alt={product.title} />
          {!product.active && <span className="badge">Hidden</span>}
        </div>

        {/* CONTENT */}
        <div className="admin-preview-content">
          <h1>{product.title}</h1>

          {product.summary && (
            <p className="summary">{product.summary}</p>
          )}

          <div className="meta">
            <span><b>Category:</b> {product.category}</span>
            <span><b>Type:</b> {product.type}</span>
            {product.material && <span><b>Material:</b> {product.material}</span>}
            {product.color && <span><b>Color:</b> {product.color}</span>}
          </div>

          <p className="description">{product.description}</p>

          <div className="price">
            €{product.price}
          </div>
        </div>

        {/* TOOLBAR */}
        <div className="admin-preview-toolbar">
          <button className="back" onClick={() => navigate(-1)}>
            ⬅ Back
          </button>

          <button
            className="edit"
            onClick={() => navigate(`/edit-card/${product.id}`)}
          >
            ✏️ Edit
          </button>
        </div>

      </div>
    </div>
  );
}
